import React, { useState } from "react";
const Clothing = () => {
  const [sortOrder, setSortOrder] = useState("");
  const [brandFilter, setBrandFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const products = [
    {
      id: 1,
      name: "Smartphone",
      price: 499,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 2,
      name: "Laptop",
      price: 999,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 3,
      name: "Headphones",
      price: 199,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 4,
      name: "Smartwatch",
      price: 299,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 5,
      name: "Tablet",
      price: 399,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 6,
      name: "Camera",
      price: 799,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 7,
      name: "Speaker",
      price: 99,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 8,
      name: "Monitor",
      price: 299,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 9,
      name: "Keyboard",
      price: 49,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
    {
      id: 10,
      name: "Mouse",
      price: 29,
      image:
        "https://thumbs.dreamstime.com/z/businesswoman-typing-laptop-workplace-woman-working-home-office-hand-keyboard-63534001.jpg?ct=jpeg",
    },
  ];

  const filteredProducts = products
    .filter((product) => {
      if (
        searchTerm &&
        !product.name.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return false;
      }
      // Filter by brand
      if (brandFilter && product.brand !== brandFilter) {
        return false;
      }
      return true;
    })
    .sort((a, b) => {
      if (sortOrder === "low-to-high") {
        return a.price - b.price;
      } else if (sortOrder === "high-to-low") {
        return b.price - a.price;
      }
      return 0;
    });

  return (
    <div className="min-h-screen bg-gray-100 text-black">
      <div className="p-4 text-white text-center bg-gray-100 mt-20">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <input
            type="text"
            placeholder="Search for products..."
            className="w-full sm:w-1/3 p-3 rounded-md text-black border-2 border-gray-400 bg-gray-50 focus:outline-none focus:border-blue-500"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select className="w-full sm:w-1/4 p-3 rounded-md text-black border-2 border-gray-400 bg-gray-50 focus:outline-none focus:border-blue-500">
            <option value="">Sub-Category</option>
            <option value="smartphones">Smartphones</option>
            <option value="laptops">Laptops</option>
            <option value="accessories">Accessories</option>
          </select>
          <select
            className="w-full sm:w-1/4 p-3 rounded-md text-black border-2 border-gray-400 bg-gray-50 focus:outline-none focus:border-blue-500"
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="">Sort by Price</option>
            <option value="low-to-high">Low to High</option>
            <option value="high-to-low">High to Low</option>
          </select>
          <select
            className="w-full sm:w-1/4 p-3 rounded-md text-black border-2 border-gray-400 bg-gray-50 focus:outline-none focus:border-blue-500"
            onChange={(e) => setBrandFilter(e.target.value)}
          >
            <option value="">Brand</option>
            <option value="Vivo">Vivo</option>
            <option value="Apple">Apple</option>
            <option value="MI">MI</option>
            <option value="Redmi">Redmi</option>
          </select>
        </div>
      </div>

      <div className="p-6 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
        {filteredProducts.map((product) => (
          <div
            key={product.id}
            className="bg-white p-4 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 ease-in-out transform hover:scale-105"
          >
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-48 object-cover rounded-lg mb-4"
            />
            <h2 className="text-lg font-bold text-gray-800">{product.name}</h2>
            <p className="text-gray-600">${product.price}</p>
            <button
              className="w-full mt-4 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              onClick={() => alert("Added to cart!")}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Clothing;
